import { createActionTypes } from "@src/utility"

export const PLAN_TYPES = createActionTypes("PLAN", [
  "GET_LIST_OF_PLANS_REQUEST",
  "GET_LIST_OF_PLANS_SUCCESS",
  "GET_LIST_OF_PLANS_FAILURE"
])
